/**
 * @generated SignedSource<<34e4bd6e89a2d21857fbff16423fb3d3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type StuffTypeEnum = "coupon" | "delivery" | "gifticon" | "premium_non_refundable" | "premium_refundable" | "%future added value";
export type StuffFilter = {
  AND?: StuffFilter | null;
  DISTINCT?: boolean | null;
  NOT?: StuffFilter | null;
  OR?: StuffFilter | null;
  createdById_Exact?: string | null;
  createdById_In?: ReadonlyArray<string> | null;
  id?: string | null;
  id_Exact?: string | null;
  id_In?: ReadonlyArray<string> | null;
  id_Not_In?: ReadonlyArray<string> | null;
  modifiedById_Exact?: string | null;
  modifiedById_In?: ReadonlyArray<string> | null;
  search?: string | null;
  type_In?: ReadonlyArray<StuffTypeEnum> | null;
};
export type StuffSelectField_stuffsQuery$variables = {
  filters?: StuffFilter | null;
};
export type StuffSelectField_stuffsQuery$data = {
  readonly stuffs: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly title: string;
      };
    }>;
  };
};
export type StuffSelectField_stuffsQuery = {
  response: StuffSelectField_stuffsQuery$data;
  variables: StuffSelectField_stuffsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "filters"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "filters",
        "variableName": "filters"
      }
    ],
    "concreteType": "StuffConnection",
    "kind": "LinkedField",
    "name": "stuffs",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "StuffEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Stuff",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "title",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "StuffSelectField_stuffsQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "StuffSelectField_stuffsQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "3ee052f3f0354ea7dcfa5be80419eb55",
    "id": null,
    "metadata": {},
    "name": "StuffSelectField_stuffsQuery",
    "operationKind": "query",
    "text": "query StuffSelectField_stuffsQuery(\n  $filters: StuffFilter\n) {\n  stuffs(filters: $filters) {\n    edges {\n      node {\n        id\n        title\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "94b09819b4bd15718ae4badd6426238e";

export default node;
